module.exports = __webpack_public_path__ + "img/rujia_3.e645e051.png";